import React, { useState } from "react";
import { SolutionDiagnosticsOption } from "../../views/GeneralTask/generalTask.types";
import { Card, Dialog, DialogContent, DialogTitle, Typography, styled } from "@mui/material";
import { MetaToolTip } from "../common/MetaToolTip";
import { MetaArguments } from "../../views/GeneralTask/generalTask.types";
import ReportImage, { SOLUTION_REPORT_DIR } from "../common/ReportImage";

interface GeneralViewMfdStaticDialogProps {
  id: string;
  option: SolutionDiagnosticsOption;
  currentImage: number;
  automationTasksLength: number;
  filteredMeta: MetaArguments;
}

const StyledTitle = styled(Typography)(() => ({
  display: "flex",
  justifyContent: "center",
  fontWeight: "bold",
}));

const StyledCard = styled(Card)(() => ({
  padding: "0px",
  maxHeight: "100%",
  width: "33%",
  objectFit: "contain",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "none",
  boxShadow: "none",
}));

const GeneralViewMfdStaticDialog: React.FC<GeneralViewMfdStaticDialogProps> = ({
  id,
  option,
  currentImage,
  automationTasksLength,
  filteredMeta,
}: GeneralViewMfdStaticDialogProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <StyledCard onClick={handleClickOpen} key={option.finalPath}>
        <ReportImage key={`${id}-${option.finalPath}`} id={id} option={option} resourceDir={SOLUTION_REPORT_DIR} />
      </StyledCard>
      <Dialog fullWidth={true} maxWidth={"lg"} open={open} onClick={handleClose} style={{ zIndex: "unset" }}>
        <DialogTitle>
          <StyledTitle>
            {currentImage + 1}&nbsp;of&nbsp;{automationTasksLength}
          </StyledTitle>
          <MetaToolTip meta={filteredMeta} />
        </DialogTitle>
        <DialogContent>
          <StyledCard key={option.finalPath} style={{ width: "100%" }}>
            <ReportImage
              key={`${id}-${option.finalPath}-dialog`}
              id={id}
              option={option}
              resourceDir={SOLUTION_REPORT_DIR}
              style={{ height: "100%", width: "50%" }}
            />
          </StyledCard>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GeneralViewMfdStaticDialog;
